import React, { createContext, useState, ReactNode, useContext } from 'react';
import Snackbar from '@mui/material/Snackbar';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';

interface SnackbarMessageContextProps {
    showMessage: (message: string) => void;
}

const SnackbarMessageContext = createContext<SnackbarMessageContextProps | undefined>(undefined);

export const SnackbarMessageProvider: React.FC<{ children: ReactNode }> = ({ children }) => {
    const [message, setMessage] = useState<string | null>(null);

    const showMessage = (msg: string) => {
        setMessage(msg);
    };


    const handleCloseSnack = () => {
        setMessage(null);
    };

    const action = (
        <React.Fragment>
            <IconButton
                size="small"
                aria-label="close"
                color="inherit"
                onClick={(event) => handleCloseSnack()}


            >
                <CloseIcon fontSize="small" />
            </IconButton>
        </React.Fragment >
    );


    return (
        <SnackbarMessageContext.Provider value={{ showMessage }}>
            {children}

            {message && (
                <Snackbar
                    open={true}

                    autoHideDuration={10000}
                    onClose={handleCloseSnack}
                    message={message}
                    action={action}
                />
            )}
        </SnackbarMessageContext.Provider>
    );
};

export const useSnackbarMessage = () => {
    const context = useContext(SnackbarMessageContext);
    if (!context) {
        throw new Error('useSnackbar must be used within a SnackbarProvider');
    }
    return context;
};
